<div class="modal-content">
    <div class="modal-header">
        <h3>{{ 'Your invoice has been submitted' | translate }}</h3>
        <div class="modal-close">
            <img class="cross-close" src="/content/icons/Close-Black.svg" (click)="navigateToHome()">
        </div>
    </div>
    <div class="modal-body" >
        <div class="modal-body-content">
            <span class="main-section">
                {{ 'Your invoice has been submitted and can now be found under invoices for the specific case.' | translate }}
                <br /><br />
                {{ 'If you are done with the case, you can navigate to home using the button below.' | translate }}
            </span>
        </div>
    </div>

    <div class="modal-footer">
        <button mat-stroked-button type="button" class="secondary" (click)="navigateToAllInvoices()">{{ 'Show all invoices on case' | translate }}</button>
        <button mat-stroked-button type="button" ngbAutofocus class="primary" (click)="navigateToHome()">{{ 'Go to home' | translate }}</button>
    </div>
</div>
